import * as Sentry from "@sentry/react";
import { environment } from '@/config/environment';

/** Sentry environment tag: 'uat' for staging, 'production' for prod. */
function getSentryEnvironment(): string {
  if (environment.STAGING) return 'uat';
  return 'production';
}

/** Sentry runs only in staging (UAT) and production when DSN is set. */
export function isSentryEnabled(): boolean {
  if (!environment.SENTRY_DSN) return false;
  return environment.STAGING || environment.PROD;
}

function shouldInitSentry(): boolean {
  return isSentryEnabled();
}

export const initSentry = () => {
  if (!shouldInitSentry()) return;

  Sentry.init({
    dsn: environment.SENTRY_DSN,
    environment: getSentryEnvironment(),
      
      // Performance monitoring - only 10% of transactions in production
      tracesSampleRate: 0.1,
      
      // Session replay - only on errors to save bandwidth
      replaysSessionSampleRate: 0.0,
      replaysOnErrorSampleRate: 1.0,
      
      // Filter out noise
      beforeSend(event, hint) {
        // Only send errors, not warnings or info
        if (event.level !== 'error') {
          return null;
        }
        
        // Filter out common non-critical errors
        const error = hint.originalException;
        if (error instanceof Error) {
          // Filter out network timeouts and script errors
          if (error.message.includes('Script error') || 
              error.message.includes('Non-Error promise rejection') ||
              error.message.includes('Network Error')) {
            return null;
          }
        }
        
        return event;
      },
      
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
    });
};
